<template>
  <div>
    <div>
      <button primary @click.prevent="goToTenantForm()" class="button is-primary">Create a new Tenant</button>
      <button @click.prevent="goToChangeTenant()" class="button" style="margin-left: 20px">Change current Tenant</button>
      <br/>
      <tenant-table></tenant-table>
    </div>
  </div>
</template>

<script>
  import TenantTable from './single/TenantTable'

  export default {
    name: 'Tenant',
    components: {
      TenantTable,
    },
    methods: {
      goToTenantForm() {
        this.$router.push({ name: 'TenantForm' })
      },
      goToChangeTenant() {
        this.$router.push({ name: 'ChangeTenant' })
      },
    }
  }
</script>
